'use strict';

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
};


Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

    var isTrue = false;
    switch (operator) {
        case '===':
            isTrue = v1 === v2;
            break;
        case '!==':
            isTrue = v1 !== v2;
            break;
        case '&lt;':
        case '<':
            isTrue = v1 < v2;
            break;
        case '&lt;=':
        case '<=':
            isTrue = v1 <= v2;
            break;
        case '&gt;':
        case '>':
            isTrue = v1 > v2;
            break;
        case '&gt;=':
        case '>=':
            isTrue = v1 >= v2;
            break;
        case '||':
            isTrue = v1 || v2;
            break;
        case '&&':
            isTrue = v1 && v2;
            break;
    }

    return isTrue ? options.fn(this) : options.inverse(this);

});


Handlebars.registerHelper('moneyFormat', function (amount) {
	var result = Shopify.formatMoney(amount);
    return result;
});


window.momentum = window.momentum || {};

momentum.cacheSelectors = function () {
	momentum.cache = {
		// General
		$html                    : $('html'),
		$body                    : $('body'),
		$window                  : $(window),

		// Navigation
		$navigation              : $('#AccessibleNav'),
		$mobileSubNavToggle      : $('.mobile-nav__toggle'),

		// Collection Pages
		$changeView              : $('.change-view'),

		// Product Page
		$productImage            : $('#productPhoto'),
		$productThumbs           : $('.productThumb'),
		$productPrice            : $('.productPrice'),
		$comparePrice            : $('.comparePrice'),
		$variantSelector         : $('.selector-wrapper'),
		$addToCartCont			 : $('#addToCartCont'),
		$addToCartButton         : $('#addToCart'),
		$addToCartText           : $('#addToCartText'),
		$cartItemCount			 : $('.cart-item-count'),
		$quantityContainer       : $('.quantity-cont'),
		$quantityInput           : $('.qty-num'),
		$quantityPlus            : $('.qty-plus'),
		$quantityMinus           : $('.qty-minus'),
		$quickShopButtons   	 : $('.quickShopButton'),
		$quickShopModal			 : $('#quickShopModal'),

		// Customer Pages
		$recoverPasswordLink     : $('#RecoverPassword'),
		$hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
		$recoverPasswordForm     : $('#RecoverPasswordForm'),
		$customerLoginForm       : $('#CustomerLoginForm'),
		$passwordResetSuccess    : $('#ResetSuccess')
	};
};

momentum.loginForms = function() {
	function showRecoverPasswordForm() {
		momentum.cache.$recoverPasswordForm.show();
		momentum.cache.$customerLoginForm.hide();
	}

	function hideRecoverPasswordForm() {
		momentum.cache.$recoverPasswordForm.hide();
		momentum.cache.$customerLoginForm.show();
	}

	momentum.cache.$recoverPasswordLink.on('click', function(evt) {
		evt.preventDefault();
		showRecoverPasswordForm();
	});

	momentum.cache.$hideRecoverPasswordLink.on('click', function(evt) {
		evt.preventDefault();
		hideRecoverPasswordForm();
	});

	// Allow deep linking to recover password form
	if (momentum.getHash() == '#recover') {
		showRecoverPasswordForm();
	}
};

momentum.utilities = function() {
	$(".force-numeric").keydown(function (event) {

		// 0-9 or numpad 0-9, disallow shift, ctrl, and alt
		if ((!event.shiftKey && !event.ctrlKey && !event.altKey) && ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)))
		{
			// check textbox value now and tab over if necessary
		}
		// not esc, del, left or right
		else if (event.keyCode != 8 && event.keyCode != 46 && event.keyCode != 37 && event.keyCode != 39)
		{
			event.preventDefault();
		}
		// else the key should be handled normally
	});
};


momentum.productQuantityButtons = function() {

	var $quantityInput = momentum.cache.$quantityInput,
		$quantityPlus = momentum.cache.$quantityPlus,
		$quantityMinus = momentum.cache.$quantityMinus;

	$('body').undelegate('.qty-minus', 'click').delegate('.qty-minus', 'click', function() {

		var curNum = parseInt( $('.qty-num').val() );
		curNum--;

		if (curNum > 100) { curNum = 100; }
		if (curNum < 1) { curNum = 1; }

		$('.qty-num').val( curNum );
		return false;

	});


	$('body').undelegate('.qty-plus', 'click').delegate('.qty-plus', 'click', function() {

		var curNum = parseInt( $('.qty-num').val() );
		curNum++;

		if (curNum > 99) { curNum = 100; }
		if (curNum < 1) { curNum = 1; }

		$('.qty-num').val( curNum );
		return false;

	});

};


momentum.productThumbSwitch = function() {

	var $thumbs = momentum.cache.$productThumbs;

	$thumbs.on('click', function(e) {

		e.preventDefault();
		$('body').css('cursor', 'progress');

		var $this = $(this),
			newSrc = $this.parent('a').attr('href'),
			alt = $this.attr('alt').replace(/"/g, '&quot;'),
			$optionSelectorOption = momentum.cache.$variantSelector.find('option[value="' + alt + '"]'),
			$singleOptionSelector = momentum.cache.$variantSelector.find('.single-option-selector');

		momentum.cache.$productImage.attr('src', newSrc);
		momentum.cache.$productImage.attr('alt', alt);

		momentum.cache.$productImage.closest('.zoom')
									.data('zoom-url', $this.data('zoom-url'))
									.attr('href', $this.data('zoom-url'));

		momentum.zoomImage();

		if ($optionSelectorOption.length > 0 && $singleOptionSelector.length > 0) {
			$optionSelectorOption.prop('selected', true);
			$singleOptionSelector.trigger('change');
		}

		$('body').css('cursor', 'default');

		return false;
	});

};



momentum.productTabs = function() {

	if (momentum.cache.$window.width() < 640) return false;

	var $h5s = $('.description h5'),
		$tabTitles = $('<ul class="tabs" data-tabs id="product-tabs" />'),
		$tabContents = $('<div class="tabs-content" data-tabs-content="product-tabs" />'),
		tabData = [];

	if ($h5s.length < 1) return false;

	$h5s.each(function(index, value){

		var num = index + 1,
			tabTitle = $(this).html(),
			tabContent = '';

		$(this).nextUntil('h5').each( function() {
			tabContent += $('<div>').append($(this).clone()).html();
		});

		tabData[ tabData.length ] = {"title": tabTitle, "content": tabContent};

	});

	$.each(tabData, function(index, item) {

		var $tabTitle = $('<li class="tabs-title"><a href="#tab' + index + '">' + item.title + '</a></li>'),
			$tabContent = $('<div class="tabs-panel row" id="tab' + index + '"><div class="small-12 large-10 medium-centered columns">' + item.content + '</div></div');

		if (index == 0) {
			$tabTitle.addClass('is-active');
			$tabContent.addClass('is-active');
		}

		$tabTitle.appendTo( $tabTitles );
		$tabContent.appendTo( $tabContents );

	});

	$('.description').html('').append($tabTitles).append($tabContents);

	var tabElem = new Foundation.Tabs($('.tabs'));

};


momentum.quickShopModal = function() {

	if (momentum.cache.$quickShopModal.length < 1) {
//		console.log('No Quick Shop Modal Found');
		return true;
	}

	if (momentum.cache.$quickShopButtons.length < 1) {
//		console.log('No Quick Shop buttons found');
		return true;
	}

	var source   = momentum.cache.$quickShopModal.first().html();
	var template = Handlebars.compile(source);

	momentum.cache.$quickShopButtons.on('click', function() {

		$('body').css('cursor', 'progress');

		var productHandle = $(this).data('product-handle'),
			quickShopUrl = $(this).data('quick-shop-url'),
			productData = {},
			newHtml = '',
			$imgTemp = $('<img />');

		if (!productHandle) {
//			console.log('No Product Handle');
			$('body').css('cursor', 'default');
			return true;
		}

		if (!quickShopUrl) {
//			console.log('No Quick Shop URL');
			$('body').css('cursor', 'default');
			return true;
		}

		productData = product_obj[ productHandle ];

		if (!productData) {
//			console.log('No Product Data');
			$('body').css('cursor', 'default');
			return true;
		}

		productData.variantCount = productData.variants.length;
		productData.imageCount = productData.images.length;
		productData.url = (typeof productData.url !== 'undefined' && productData.url.length > 0) ? productData.url : '/products/' + productData.handle;

		newHtml = template(productData);

		momentum.cache.$quickShopModal.html( newHtml ).promise().done( function() {

			$imgTemp.attr("src", productData.featured_image)
					.one('load', function() {
						setTimeout( function() {
							momentum.cache.$quickShopModal.foundation('open');
							momentum.cacheSelectors();
							momentum.productTabs();
							momentum.productQuantityButtons();
							momentum.productThumbSwitch();
						}, 1);
					}).each(function() {
						if(this.complete) $(this).load();
					});

		});

		// Setup new option selectors

		setTimeout( function() {

			if (productData.variantCount > 1) {
				new Shopify.OptionSelectors('productSelect', {
					product: productData,
					onVariantSelected: momentum.selectCallback,
					enableHistoryState: false
				});
			}

			// Add label if only one product option and it isn't 'Title'. Could be 'Size'.
			if (productData.options.length == 1 && productData.options[0] != 'Title') {
				$('.selector-wrapper:eq(0)').prepend('<label for="productSelect-option-0">' + productData.options[0] + '</label>');
			}

			// Hide selectors if we only have 1 variant and its title contains 'Default'.
			if (productData.variants.length == 1 && productData.variants[0].title == 'Default') {
				$('.selector-wrapper').hide();
			}
		}, 500);

		$('body').css('cursor', 'default');

		return false;

	});

};


momentum.switchImage = function (src, imgObject, el) {
	// Make sure element is a jquery object
	var $el = $(el);
	$el.attr('src', src);
};


momentum.variantSwatches = function() {

	$('.product-list-swatch').on('click', function() {

		var $this	     = $(this),
			variantImg   = $this.attr('data-variant-img'),
			variantUrl   = $this.attr('data-variant-url'),
			variantPrice = $this.attr('data-variant-price'),
			productCont  = $this.closest('.product-thumb-cont'),
			variantPrice = variantPrice.replace(' ', ''),
			$mainImg     = productCont.find('.product-thumb'),
			$mainLnk     = productCont.find('.product-link'),
			$price       = productCont.find('.product-price');

		if ($mainImg.length && (variantImg != '')) {

			if (variantUrl != '') { $mainLnk.attr( 'href', variantUrl ); }
			if (variantPrice != '') { $price.text(variantPrice); }

			if ($mainImg.attr('src') != variantImg) {

				var $tmpImg = $('<img />').attr( 'src', variantImg );

				Foundation.onImagesLoaded($tmpImg, function() {
					$mainImg.fadeOut( function() {
						$mainImg.attr( 'src', variantImg ).fadeIn();
					});
				});
			}

			return false;
		}

		return true;
	});

};

momentum.zoomImage = function() {
	$('.zoom').each( function() {
		if (typeof $(this).data('zoom-url') != 'undefined') {
			$(this).trigger('zoom.destroy').zoom({
				url: $(this).data('zoom-url')
			});
		}
	})
	.on('click', function() { return false; })
	.on('mouseover', function() { $(this).css('cursor', 'crosshair'); });
};


momentum.productPage = function (options) {

	var moneyFormat  = options.money_format,
			variant  = options.variant,
			selector = options.selector;

	if (!window.momentum || !window.momentum.cache ) {
		momentum.cacheSelectors();
	}

	if (variant) {

		if ($('#quickShopVariantId').length) {
			$('#quickShopVariantId').val( variant.id );
		}

		momentum.cache.$addToCartButton.off('click').on('click', function(e) {
			e.preventDefault();

			try {
				Shopify.addItemFromForm('form-product');
			} catch(errMsg) {
				return true;
			}

			$('#addToCartMessage').remove();

			var addToCartMessage = $('<div id="addToCartMessage">Item(s) added to cart!<br /><a class="product-checkout" href="/cart">Check Out</a></div>')
				.appendTo( momentum.cache.$addToCartCont )
				.hide()
				.fadeIn();

			return false;
		});

		// Update variant image, if one is set
		if (variant.featured_image) {
			var newImg = variant.featured_image,
					el = momentum.cache.$productImage[0];
			Shopify.Image.switchImage(newImg, el, momentum.switchImage);

			momentum.cache.$productImage.closest('.zoom')
										.data('zoom-url', newImg.src)
										.attr('href', newImg.src)
										.find('.zoomImg')
										.attr('src', newImg.src);

		}

		// Select a valid variant if available
		if (variant.available) {
			// Available, enable the submit button, change text, show quantity elements
			momentum.cache.$addToCartButton.removeClass('disabled').prop('disabled', false);
			momentum.cache.$addToCartText.html("Add to cart");
			momentum.cache.$quantityContainer.show();
		} else {
			// Sold out, disable the submit button, change text, hide quantity elements
			momentum.cache.$addToCartButton.addClass('disabled').prop('disabled', true);
			momentum.cache.$addToCartText.html("Sold out");
			momentum.cache.$quantityContainer.hide();
		}

		// Regardless of stock, update the product price
		momentum.cache.$productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
		console.log('Money Format: ', moneyFormat);

		// Also update and show the product's compare price if necessary
		// if (variant.compare_at_price > variant.price) {
		// 	momentum.cache.$comparePrice
		// 		.html("Compare At" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
		// 		.show();
		// } else {
		// 	momentum.cache.$comparePrice.hide();
		// }

	} else {
		// The variant doesn't exist, disable submit button.
		// This may be an error or notice that a specific variant is not available.
		// To only show available variants, implement linked product options:
		//   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
		momentum.cache.$addToCartButton.addClass('disabled').prop('disabled', true);
		momentum.cache.$addToCartText.html("Unavailable");
		momentum.cache.$quantityContainer.hide();
	}
};


momentum.selectCallback = function(variant, selector) {
	momentum.productPage({
		money_format: "",
		variant: variant,
		selector: selector
	});
};


momentum.shopifyAPISetup = function() {

	Shopify.onItemAdded = function(line_item) {
		console.log('Line Item:', line_item);
		console.log(line_item.title + ' was added to your shopping cart.');
		Shopify.getCart();
	};

	Shopify.onCartUpdate = function(cart) {
		console.log('Cart Updated!');
		console.log('Cart: ', cart);
		momentum.cache.$cartItemCount.text(cart.item_count);
	};

};


momentum.instafeed = function () {
	return false;
};


momentum.carousel = function() {
/*
	$("#homepage-stage").owlCarousel({
			animateIn: ',',
			animateOut: '',
			autoplay: ,
			autoplayTimeout: ,
			autoplayHoverPause: ,
			items: ,
			loop: ,
			margin: ,
			navigation: true,
			smartSpeed: 450,
			stagePadding: ,
			responsive : {
				0 : {
					mouseDrag : true
				}
			}
	});
*/
};


momentum.newsletterPopup = function() {
	$(document).on('ready', function() {

		var cookieNewsletterPopup = Cookies.get('newsletterPopup');
		console.log(cookieNewsletterPopup);

		if (typeof cookieNewsletterPopup == 'undefined') {
			$('#newsletterPopup').foundation('open');
			cookieNewsletterPopup = Cookies.set('newsletterPopup', 'true', { expires: 30 });
		}
	});
};


momentum.cartPage = function() {

	$(window).on('load', function() {
		var $cartItemRows = $('.cart-item-row');

		if (parseInt(momentum.cache.$window.width()) < 769) {
			$cartItemRows.each( function( index, element ) {
				$(element).removeAttr('data-equalizer');
				$(element).children().removeAttr('data-equalizer-watch').css('height', 'auto');
			});
		}

	});

	return true;

};


momentum.filterable = function() {

	$(document).ready( function() {
		var $filterSelect = $('.filterSelect'),
			$container = $('.filterable');

		if ($container.length > 0) {
			$container.mixItUp();

			if ($filterSelect.length > 0) {
				console.log('changed');
		  		$filterSelect.on('change', function(){
		  			console.log('Value:', this.value);
					$container.mixItUp('filter', this.value);
				});
		  	}
		}
	});

};


momentum.filters = function() {
	var $filterSelects = $('select.filter');

	$filterSelects.on('change', function() {
		console.log("Filter Changed");
		var filter_value = $(this).val() || 'collections/all';
		document.location.href = filter_value + document.location.search;
	});
};


momentum.sorting = function() {
	var $sortSelects = $('select.sort');

	$sortSelects.on('change', function() {
		var query = '',
			sort_value = $(this).val() || 'title-ascending';

		if (sort_value !== 'title-ascending') {
			query = ['sort_by=' + sort_value];
		}
		document.location.search = query.length ? '?' + query : '';
//		this._resizeSelect($(evt.target));
	});
};


momentum.marketPlace = function() {
	$(document).ready(function() {

		var $filterSelect = $('.filterSelect'),
			$container = $('.filterable');

		if ($container.length > 0) {
		  var mixer = mixitup('.filterable', {
				    selectors: {
				        target: '.mix'
				    },
				    animation: {
				        duration: 300
				    }
				}),
	  		$filterContainer = $('.filterable'),
		  	$thirdStreetLink = $('.filter-third-street'),
		  	$studioCityLink = $('.filter-studio-city');

		  if ($('body#marketplace').length < 1) return false;

		  if ($thirdStreetLink.length > 0) {
			  $('.filter-third-street').on('click', function(e) {
			    e.preventDefault();
			    e.stopPropagation();
			    $('.studio-city-daily-specials').fadeOut( function() {
				    $('.third-street-daily-specials').fadeIn();
			    });
			    $thirdStreetLink.addClass('active');
			    $studioCityLink.removeClass('active');
			    mixer.filter('.third-street');
			    $filterContainer.mixItUp('filter', '.third-street');
                
                $('.marketplace-sub-header').each(function() {
                  $(this).stop(true, true);
                  if($(this).prev().length) {
                    $(this).css('opacity', 0);
                  }
                });
                
                $thirdStreetLink.addClass('active');
                $studioCityLink.removeClass('active');
                $filterContainer.mixItUp('filter', '.third-street', function () {
                  //setTimeout(function() {
                    $('.marketplace-sub-header').stop(true, true).animate({opacity: 1});
                  //}, 600);
                });

			    return false;
			  });
			  $('.filter-third-street').trigger('click');
			}

		  if ($studioCityLink.length > 0) {
			  $('.filter-studio-city').on('click', function(e) {
			    e.preventDefault();
			    e.stopPropagation();
			    $('.third-street-daily-specials').fadeOut( function() {
				    $('.studio-city-daily-specials').fadeIn();
			    });
			    $studioCityLink.addClass('active');
			    $thirdStreetLink.removeClass('active');
			    mixer.filter('.studio-city');
	 		    $filterContainer.mixItUp('filter', '.studio-city');
                
                $('.marketplace-sub-header').each(function() {
                  $(this).stop(true, true);
                  if($(this).prev().length) {
                    $(this).css('opacity', 0);
                  }
                });
                
                $studioCityLink.addClass('active');
                $thirdStreetLink.removeClass('active');
                $filterContainer.mixItUp('filter', '.studio-city', function () {
                  //setTimeout(function() {
                    $('.marketplace-sub-header').stop(true, true).animate({opacity: 1});
                  //}, 600);
                });

			    return false;
			  });
			}
		}

	});
};

momentum.smoothScroll = function() {
  $('a').on('click', function(event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
        window.location.hash = hash;
      });
    }
  });
}

momentum.anchorScroll = function () {
  function getHeaderOffset() {
    var offset = 0;

    $('#header-promotional-bar:visible, #main-menu, #top-bar-cont, .top-bar').each(function () {
      var $el = $(this);
      var position = $el.css('position');

      if (position === 'fixed' || position === 'sticky') {
        offset += $el.outerHeight();
      }
    });

    return offset + 16;
  }

  function scrollToHash(hash, updateHistory) {
    if (!hash || hash === '#') return false;

    var $target = $(hash);
    if (!$target.length) return false;

    var top = Math.max($target.offset().top - getHeaderOffset(), 0);

    $('html, body').stop(true).animate({ scrollTop: top }, 700);

    if (updateHistory !== false && history.replaceState) {
      history.replaceState(null, null, hash);
    }

    return true;
  }

  function samePageHash(link) {
    if (!link.hash || link.hash === '#') return null;

    var linkPath = link.pathname.replace(/\/$/, '') || '/';
    var pagePath = window.location.pathname.replace(/\/$/, '') || '/';

    if (linkPath !== pagePath) return null;

    return link.hash;
  }

  function shouldSkipAnchor(link) {
    if (link.getAttribute('role') === 'button') return true;
    if ($(link).closest('.tabs-title, .tabs, .is-drilldown-submenu-parent').length) return true;
    return false;
  }

  $(document).on('click', 'a[href*="#"]', function (e) {
    if (shouldSkipAnchor(this)) return;

    var hash = samePageHash(this);
    if (!hash || !$(hash).length) return;

    e.preventDefault();
    scrollToHash(hash);
  });

  function scrollOnLoad() {
    if (!window.location.hash) return;

    window.setTimeout(function () {
      scrollToHash(window.location.hash, false);
    }, 150);
  }

  scrollOnLoad();
  $(window).on('hashchange', function () {
    scrollToHash(window.location.hash, false);
  });
};

momentum.aboutCareersToggle = function() {
  
  $('.about-careers-job-main').on('click', function() {
    
    var $this = $(this);
    
    $this.toggleClass('active');
    
    if ($this.hasClass('active')) {
      $this.find('.about-careers-job-plus').text('-');
    } else {
      $this.find('.about-careers-job-plus').text('+');
    }
    
    $this.next('.about-careers-job-description').slideToggle(300);
    
  });
  
}

momentum.init = function () {

	$(document).foundation();
	momentum.cacheSelectors();
	momentum.loginForms();
	momentum.cartPage();
	
	
	momentum.productQuantityButtons();
	momentum.productThumbSwitch();
	momentum.variantSwatches();
	momentum.filters();
	momentum.sorting();
	
	
	momentum.shopifyAPISetup();
	momentum.instafeed();
	momentum.anchorScroll();
	momentum.carousel();
	momentum.utilities();
	momentum.filterable();
	//momentum.smoothScroll();
	momentum.marketPlace();
    //momentum.aboutCareersToggle();
  
};


momentum.getHash = function () {
	return window.location.hash;
};


momentum.updateHash = function (hash) {
	window.location.hash = '#' + hash;
	$('#' + hash).attr('tabindex', -1).focus();
};


$(document).on('ready', function () {
	momentum.init();
});


/*============================================================================
  Date Picker
==============================================================================*/
jQuery(function() {

	if(jQuery("#date").length){
      
		var today = new Date();
      	var productLink = $('a').filter(function(index) { return $(this).text() === "Sweet & Salty Box... Available to ship nation wide"; });
        var blackoutDatesString = "21-08-08,2021-15-08,2021-22-08,2021-29-08,2021-09-05,2021-09-06,2021-09-12,2021-09-19,2021-09-26,2021-10-03,2021-10-10,2021-10-17,2021-10-24,2021-10-31,2021-11-07,2021-11-14,2021-11-21,2021-11-24,2021-11-25,2021-11-28,2021-12-05,2021-12-12,2021-12-13,2021-12-14,2021-12-15,2021-12-16,2021-12-18,2021-12-19,2021-12-20,2021-12-21,2021-12-22,2021-12-24,2021-12-25,2021-12-26,2021-12-27,2021-12-28,2021-12-31,2022-01-01,2022-01-02,2022-01-03,2022-01-04,2022-01-05,2022-01-09,2022-01-16,2022-01-22,2022-01-23,2022-01-29,2022-01-30,2022-02-05,2022-02-06,2022-02-12,2022-02-13,2022-02-19,2022-02-20,2022-02-27,2022-03-06,2022-03-13,2022-03-20,2022-03-27,2022-04-03,2022-04-10,2022-04-15,2022-04-16,2022-04-17,2022-04-24,2022-04-24,2022-05-01,2022-05-08,2022-05-15,2022-05-22,2022-05-29,2022-06-05,2022-06-12,2022-06-19,2022-06-26,2022-07-03,2022-07-4,2022-07-10,2022-07-17,2022-07-24,2022-07-31,2022-08-07,2022-08-14,2022-08-21,2022-08-28,2022-09-04,2022-09-05,2022-09-11,2022-09-18,2022-09-25,2022-09-26,2022-10-02,2022-10-04,2022-10-09,2022-10-16,2022-10-22,2022-10-23,2022-10-30,2022-11-06,2022-11-19,2022-11-13,2022-11-20, 2022-11-23,2022-11-24,2022-11-25,2022-11-26,2022-11-27,2022-12-04,2022-12-11,2022-12-18,2022-12-19,2022-12-24,2022-12-25,2022-12-26,2022-12-31,2023-01-01,2023-01-02,2022-01-08,2022-01-15,2022-01-22,2022-01-29,2022-02-05,2022-02-12,2022-02-19,2022-02-26,2022-02-05,2022-11-23,2022-11-24,2022-11-27,2022-12-04,2022-12-18,2022-12-11,2022-12-18,2022-12-19,2022-12-15,2022-12-24,2022-12-25,2022-12-26,2022-12-31,2023-01-01,2023-01-08,2023-01-15,2023-01-22,2023-01-29,2023-02-12,2023-02-19,2023-02-26,2023-03-05,2023-03-12,2023-03-19,2023-03-26,2023-04-02,2023-04-05,2023-04-06,2023-04-09,202-04-16,2023-04-23,2023-04-30,2023-05-07,2023-05-14,2023-05-21,2023-05-27,2023-05-28,2023-05-29,2023-06-04,2023-06-11,2023-06-18,2023-06-25,2023-07-02,2023-07-04,2023-07-09,2023-07-30,2023-08-06,2023-08-13,2023-08-20,2023-08-27,2023-09-03,2023-09-04,2023-09-10,2023-09-16,2023-09-17,2023-09-24,2023-09-25,2023-10-01,2023-10-08,2023-10-15,2023-10-22,2023-10-29,2023-11-05,2023-11-12,2023-11-19,2023-11-22,2023-11-23,2023-11-24,2023-11-25,2023-11-26,2023-12-02,2023-12-03,2023-12-7,2023-12-8,2023-12-09,2023-12-10,2023-12-16,2023-12-17,2023-12-23,2023-12-24,2023-12-25,2023-12-26,2023-12-30,2023-12-31,2024-01-01,2024-01-02,2024-01-06,2024-01-07,2024-01-13,2024-01-14,2024-01-20,2024-01-21,2024-2-28,2024-01-27,2024-02-04,2024-02-11,2024-02-14,2024-02-18,2024-02-25,2024-03-03,2024-03-10,2024-03-17,2024-03-24,2024-03-30,2024-03-31,2024-04-07,2024-04-14,2024-04-13,2024-04-14,2024-04-21,2024-04-22,2024-04-23,2024-04-24,2024-04-28,2024-05-05,2024-05-12,2024-05-18,2024-05-19,2024-05-25,2024-05-26,2024-06-01,2024-06-02,2024-06-08,2024-06-09,2024-06-15,2024-06-16,2024-06-22,2024-06-23,2024-06-29,2024-06-30,2024-07-03,2024-07-04,2024-07-06,2024-07-07,2024-07-13,2024-07-14,2024-07-20,2024-07-21,2024-07-27,2024-07-28,2024-08-3,2024-08-04,2024-08-10,2024-08-11,2024-08-17,2024-08-18,2024-08-24,2024-08-25,2024-08-31,2024-09-01,2024-09-02,2024-09-07,2024-09-08,2024-09-14,2024-09-15,2024-09-21,2024-09-22,2024-09-28,2024-09-29,2024-10-03,2024-10-04,2024-10-05,2024-10-06,2024-10-11,2024-10-12,2024-10-13,2024-10-19,2024-10-20,2024-10-26,2024-10-27,2024-11-02,2024-11-03,2024-11-09,2024-11-10,2024-11-16,2024-11-17,2024-11-23,2024-11-24.2024-11-27,2024-11-28,2024-11-29,2024-11-30,2024-12-01,2024-12-07,2024-12-08,2024-12-14,2024-12-15,2024-12-21,2024-12-22,2024-12-24,2024-12-25,2024-12-26,2024-12-28,2024-12-29,2024-12-31,2025-01-01,2025-01-02,2025-01-03,2025-01-04,2025-01-05,2025-01-11,2025-01-12,2025-19-01,2025-26-01,2025-02-02,2025-02-09,2025-02-16,2025-02-23,2025-03-02,2025-03-09,2025-03-16,2025-03-23,2025-03-30,2025-04-06,2025-04-13,2025-04-13,2025-04-19,2025-04-20,2025-04-27,2025-05-04,2025-05-11,2025-05-12,2025-05-18,2025-05-25,2025-05-26,2025-06-01,2025-06-08,2025-06-15,2025-06-22,2025-06-29,2025-07-03,2025-07-04,2025-07-06,2025-07-13,2025-07-20,2025-07-27,2025-08-03,2025-08-10,2025-08-17,2025-08-24,2025-08-31,2025-9-01,2025-09-07,2025-09-14,2025-09-21,2025-09-22,2025-09-23,2025-09-28,2025-10-01,2025-10-02,2025-10-05,2025-10-12,2025-10-19,2025-10-26,2025-11-02,2025-11-09,2025-11-16,2025-11-23,2025-11-26,2025-11-27,2025-11-28,2025-11-30,2025-12-06,2025-12-07,2025-12-13,2025-12-14,2025-12-15,2025-12-21,2025-12-24,2025-12-25,2025-12-26,2025-12-27,2025-12-28,2025-12-31,2026-01-01,2026-01-02,2026-01-04,2026-01-11,2026-02-08,2026-02-15,2026-02-22,2026-03-01,2026-03-08,2026-03-15,2026-03-22,2026-03-29,2026-04-01,2026-04-05,2026-04-12,2026-04-19,2026-04-26,2026-05-03,2026-05-10,2026-05-17,2026-05-24,2026-05-31,2026-06-07,2026-06-14,2026-06-21,2026-06-28,2026-07-04,2026-07-05,2026-07-12,2026-07-19,2026-07-26,2026-08-02,2026-08-09,2029-08-16,2026-08-23,2026-08-30,2026-09-06,2026-09-07,2026-09-12,2026-09-13,2026-09-20,2026-09-21,2026-09-27,2026-10-4-2026-10-11,2026-10-18,2026-10-25,2026-10-31,2026-11-01,2026-11-08-2026-11-14-2026-11-15-2026-11-21-2026-11-22,2026-11-25,2026-11-26,2026-11-27,2026-11-28,2026-11-29,2026-12-5,2026-12-6,2026-12-12,2026-12-13,2026-12-19,2026-12-20,2026-12-24,2026-12-25,2026-12-26,2026-12-27,2026-12-31,2027-01-01,2027-01-03,2027-01-10,2027-01-17,2027-01-24,2027-01-31,2027-02-07";
      	var datesArray = blackoutDatesString.split(',');
      	var superBowlProduct = $('a:contains("Super Bowl Celebration Box")');
      	var deadlineHour = 14;
      	var daysNotice = productLink.length > 0 ? 4 : 2;
        
        if (superBowlProduct.length > 0) {
          	jQuery("#date").datepicker( { 
                minDate: new Date(2022, 1, 11), 
                maxDate: new Date(2022, 1, 13),
            } );
          
        } else {
          	jQuery("#date").datepicker( { 
                beforeShowDay: function(date){
                    var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
                    return [ datesArray.indexOf(string) == -1 ]
                },
                minDate: today.getHours() >= deadlineHour ? daysNotice + 1 : daysNotice, 
                maxDate: '+2M',
            } );
        }
      
	}
  
});